import React from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";

const empty = { category: "Allgemein", order: 0, enabled: true, question_de: "", answer_de: "", question_en: "", answer_en: "" };

export default function FaqAdmin() {
  const [items, setItems] = React.useState([]);
  const [draft, setDraft] = React.useState({ ...empty });
  const [editId, setEditId] = React.useState(null);

  const load = () => api.adminFaq().then(setItems);
  React.useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editId) await api.updateFaq(editId, draft);
      else await api.createFaq(draft);
      toast.success("Gespeichert");
      setDraft({ ...empty }); setEditId(null); load();
    } catch { toast.error("Fehler"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Löschen?")) return;
    await api.deleteFaq(id); load();
  };
  const edit = (it) => { setDraft(it); setEditId(it.id); };

  return (
    <div data-testid="admin-faq">
      <div className="mb-6"><div className="brut-tag mb-3">CMS / FAQ</div><h1 className="brut-h2">FAQ</h1></div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-7 space-y-3">
          {items.map(it => (
            <div key={it.id} className="border-2 border-[var(--ink)] p-4" data-testid={`faq-item-${it.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-60">{it.category}</div>
                  <div className="brut-h3 mt-1">{it.question_de}</div>
                  <p className="brut-body opacity-80 mt-2 text-sm whitespace-pre-line">{it.answer_de}</p>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => edit(it)} className="font-mono text-xs underline">Edit</button>
                  <button onClick={() => remove(it.id)} className="font-mono text-xs underline text-red-600">Del</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="col-span-12 md:col-span-5">
          <div className="border-2 border-[var(--ink)] p-4 space-y-3 sticky top-6">
            <div className="font-mono text-xs uppercase tracking-[0.2em]">{editId ? "Eintrag bearbeiten" : "Neuer Eintrag"}</div>
            <input className="brut-input" placeholder="Kategorie" value={draft.category} onChange={e => setDraft({ ...draft, category: e.target.value })} />
            <input className="brut-input" placeholder="Frage (DE)" value={draft.question_de} onChange={e => setDraft({ ...draft, question_de: e.target.value })} />
            <textarea rows={4} className="brut-textarea" placeholder="Antwort (DE)" value={draft.answer_de} onChange={e => setDraft({ ...draft, answer_de: e.target.value })} />
            <input className="brut-input" placeholder="Question (EN)" value={draft.question_en || ""} onChange={e => setDraft({ ...draft, question_en: e.target.value })} />
            <textarea rows={3} className="brut-textarea" placeholder="Answer (EN)" value={draft.answer_en || ""} onChange={e => setDraft({ ...draft, answer_en: e.target.value })} />
            <div className="flex gap-2">
              <button onClick={save} className="brut-btn !py-2 !px-3 text-xs"><Save size={12}/> Speichern</button>
              {editId && <button onClick={() => { setDraft({ ...empty }); setEditId(null); }} className="font-mono text-xs underline">Abbrechen</button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
